/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="92.84"
        height="92.55"
        viewBox="0 0 92.84 92.55"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M75.61 92.48h-2.5v-5.26c0-9.66-17.84-13.11-24.16-14a17.89 17.89 0 0 1-11.17 3.54 18.51 18.51 0 0 1-11.06-3.5c-11.3 1.71-24.22 6.34-24.22 14v5.26H0v-5.26c0-9.31 13.89-14.63 26.88-16.5a1.29 1.29 0 0 1 1 .26 16 16 0 0 0 9.93 3.29 15.38 15.38 0 0 0 10-3.35 1.29 1.29 0 0 1 .95-.27C73 74 75.61 83.38 75.61 87.26ZM68.24 50.89a1.18 1.18 0 0 1-.53-.12 1.24 1.24 0 0 1-.71-1.13v-7.71h-7.39a1.25 1.25 0 0 1 0-2.5h8.65a1.25 1.25 0 0 1 1.25 1.25V47l8.76-7.26a1.29 1.29 0 0 1 .8-.29h5.88a5.39 5.39 0 0 0 5.41-5.25V7.76a5.35 5.35 0 0 0-5.41-5.25H42.61a5.35 5.35 0 0 0-5.41 5.25v15.79a1.25 1.25 0 0 1-2.5 0V7.76A7.85 7.85 0 0 1 42.61.01h42.36a7.85 7.85 0 0 1 7.91 7.75v26.43a7.84 7.84 0 0 1-7.91 7.75h-5.43l-10.5 8.67a1.25 1.25 0 0 1-.8.29M27.44 48c.56 8 5.64 15.75 10.63 15.75 5.33 0 10-7.57 10-16.21a16.08 16.08 0 0 0-1.62-7.59c-2.14 2.17-7.57 6.27-19 8m10.62 18.28C31.13 66.23 25.64 57 25 48.31c-1.49.18-3.07.31-4.74.4l-.13-2.49c20.16-1.09 25.38-8.93 25.43-9l.93-1.46 1.09 1.34c3.38 4.14 3 10.25 3 10.51 0 9-5 18.63-12.51 18.63"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M25.61 68.39c-6.7-11.52-8.11-24.6-3.53-32.56 3-5.3 8.53-8.1 15.83-8.1 6.74 0 11.94 2.75 15 7.94 4.79 8 3.78 20.84-2.58 32.68l-2.2-1.18c6-11.08 7-22.94 2.63-30.22-2.62-4.39-7.08-6.72-12.89-6.72-6.45 0-11 2.3-13.66 6.84-4.09 7.1-2.64 19.46 3.52 30.06Z"
          className="icon-fill icon-base"/><path
          fill="#ffb81c"
          d="M63.91 9.76a6.24 6.24 0 0 0-6.24 6.23 8.34 8.34 0 0 0 1.67 4.58A10.18 10.18 0 0 1 61 24.15h6a10.88 10.88 0 0 1 1.62-3.59 8.29 8.29 0 0 0 1.53-4.57 6.25 6.25 0 0 0-6.24-6.23ZM60 26.15a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71 7 7 0 0 0-1.4-3.56 10.2 10.2 0 0 1-2-5.62 8.24 8.24 0 0 1 16.48 0 10.2 10.2 0 0 1-1.91 5.62 7.61 7.61 0 0 0-1.45 3.61 1 1 0 0 1-1 .94ZM67.93 27.55c-.2 2.22-.57 5.42-3.88 5.42-3.7 0-4-3.32-4.16-5.42"
          className="icon-fill icon-accent"/><path
          fill="#ffb81c"
          d="M59.89 17.39h-.1a1 1 0 0 1-.9-1.09 5.76 5.76 0 0 1 1.66-3.51 4.64 4.64 0 0 1 3.53-1.27 1 1 0 0 1 .85 1.13 1 1 0 0 1-1.11.85 2.85 2.85 0 0 0-2 .81 3.85 3.85 0 0 0-1 2.18 1 1 0 0 1-1 .91"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'PersonWithLightbulbWordBubbleIcon';

export default Icon;
